<div class="bg-white">
  <!-- Header -->
  <div class="flex items-center justify-center h-[70px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium">
      Link Module
    </h4>
  </div>

  <mat-dialog-content class="!pt-0 bg-white">
    <form [formGroup]="linkModuleForm" class="!mt-1">
      <!-- Source info -->
      <p class="text-[12px] text-start text-[#944e0e] mb-4 font-sans font-semibold">
        <span class="text-black">Source Module:</span> {{ dialogData?.headerMsg }}
      </p>

      <!-- Target module dropdown -->
      <div class="w-full">
        <mat-form-field appearance="outline" class="w-full cmn-sm-form-field custom-form-validation">
          <mat-label>Target Module</mat-label>
          <mat-select formControlName="targetModule" (selectionChange)="onTargetModuleChanged($event.value)">
            @for (m of targetModules; track m) {
              <mat-option [value]="m">{{ m }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Search multi-select -->
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search w-full sm-form-field">
        <mat-label>Search {{ selectedTargetModule }}</mat-label>
        <mat-icon matPrefix class="text-lg" svgIcon="c:search"></mat-icon>
        <input matInput type="text" placeholder="Search {{ selectedTargetModule }}" [formControl]="searchCtrl"
          [matAutocomplete]="auto" (focus)="autoTrigger.openPanel()" (click)="autoTrigger.openPanel()"
          #autoTrigger="matAutocompleteTrigger" />

          <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
            <div class="search-list-heading">
              {{ selectedTargetModule }} Results
            </div>
            <div class="search-list-scroll">
              @for (item of filteredItems(); track item) {
                <mat-option [value]="null" (click)="toggleFromSearch(item)">
                  <mat-checkbox [checked]="isSelected(item.id)" (click)="$event.stopPropagation()"
                    (change)="toggleFromSearch(item, $event.checked)">
                  </mat-checkbox>
                  <span class="opt-label">{{ item.name }}</span>
                </mat-option>
              }
            </div>
          </mat-autocomplete>
        </mat-form-field>

        <!-- Linked Items Card -->
        <!-- Linked Items Section -->
        <div class="mt-4 rounded-md border shadow-sm overflow-hidden">
          <div class="bg-slate-500 text-white px-4 py-2">
            <h3 class="text-xs font-medium">
              Linked {{ selectedTargetModule }} Items
            </h3>
          </div>

          <!-- Scrollable List -->
          <div class="max-h-[180px] overflow-y-auto divide-y bg-white">
            @for (row of rows; track row) {
              <div class="flex justify-between items-center px-4 py-2 text-xs hover:bg-gray-50">
                <div>{{ row.displayText }}</div>
                <button (click)="onDelete(row)" data-toggle="tooltip" title="Delete">
                  <mat-icon class="!text-red pr-1 c-fa" svgIcon="c:trash"></mat-icon>
                </button>
              </div>
            }
          </div>

          <!-- Empty State -->
          @if (rows.length === 0) {
            <div class="px-4 py-3 text-xs text-gray-500 italic bg-gray-50">
              No {{ selectedTargetModule }} items linked yet.
            </div>
          }
        </div>


        <!-- Footer -->
        <mat-dialog-actions class="!p-0 flex !justify-center !mt-4 !mb-3">
          <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button">
            Cancel
          </button>
          <button mat-flat-button color="primary" class="text-primary primary-button" (click)="onSubmit()"
            cdkFocusInitial>
            Save
          </button>
        </mat-dialog-actions>
      </form>
    </mat-dialog-content>
  </div>